// extracted by mini-css-extract-plugin
module.exports = {"root":"Moments_root__1ySXs","headingSpacer":"Moments_headingSpacer__COjcB","information":"Moments_information__LPyJU","details":"Moments_details__TOxBy"};